import { trigger, animate, transition, style, state } from '@angular/animations';

export const wobble = trigger('wobble', [
    state('left', style({
        transform: 'rotateY(15deg)',
        'transform-style': 'preserve-3d'
    })),
    state('right', style({
        transform: 'rotateY(-15deg)',
        'transform-style': 'preserve-3d'
    })),
    transition('* <=> *', animate('3s ease-in-out')),
]);
